/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

// Disable eslint error for google object
/* global google */

import React from 'react'
import autoBind from 'react-autobind'

import TextField from './TextField'

export default class GoogleAutoCompleteField extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.input = null
    this.autocomplete = null
  }

  handleAddressSelect () {
    const places = this.autocomplete.getPlace()
    let addressObject = {}

    places.address_components && places.address_components.forEach((addressItem) => {
      addressObject[addressItem.types[0]] = addressItem.long_name
    })

    addressObject.name = (addressObject.route ? addressObject.route + ' ' : '') + (addressObject.street_number || '')
    this.props.handleAutocomplete(addressObject, places.formatted_address)
  }

  componentDidMount () {
    // Focus search around Switzerland
    const bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(45.8679826, 5.8621257),
      new google.maps.LatLng(47.8837119, 10.2807922)
    )

    this.autocomplete = new google.maps.places.Autocomplete(this.input, {bounds: bounds})

    this.autocomplete.addListener('place_changed', this.handleAddressSelect)
  }

  setInput (input) {
    if (input) {
      this.input = input
    }
  }

  render () {
    const { handleAutocomplete, ...rest } = this.props

    return (
      <TextField {...rest} getField={this.setInput} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/generic/form/GoogleAutoCompleteField.js